/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreatePathologyDto } from './create-pathology-dto';
import { EnLevel } from './en-level';
import { EnUserAffectedSide } from './en-user-affected-side';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UpdateUserPathologyDto
 */
export interface UpdateUserPathologyDto {

    /**
     * @type {boolean}
     * @memberof UpdateUserPathologyDto
     */
    comorbidity?: boolean;

    /**
     * @type {boolean}
     * @memberof UpdateUserPathologyDto
     */
    chronic?: boolean;

    /**
     * @type {boolean}
     * @memberof UpdateUserPathologyDto
     */
    acute?: boolean;

    /**
     * @type {string}
     * @memberof UpdateUserPathologyDto
     */
    start?: string;

    /**
     * @type {EnUserAffectedSide}
     * @memberof UpdateUserPathologyDto
     */
    affectedSide?: EnUserAffectedSide | null;

    /**
     * @type {EnLevel}
     * @memberof UpdateUserPathologyDto
     */
    level?: EnLevel | null;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateUserPathologyDto
     */
    user?: JoinEntityDto | null;

    /**
     * @type {CreatePathologyDto | JoinEntityDto}
     * @memberof UpdateUserPathologyDto
     */
    pathology?: CreatePathologyDto | JoinEntityDto;
}
